import ChatInputControl from "./ChatInput";

const ChatInputWrapper = ({
  isThreadScreen,

  // Common props for ChatInputControl
  handleclickAttherate,
  handleMessageSend,
  handleOnChangeNewMessage,
  newMessages,
  handleClickYouTube,
  setFileAttachment,
  handleClickGoogle,
  fileAttachment,
  attachment,
  setAttachment,
  isTaskTypeModalOpen,
  isTaskUpdateOpen,
  setIsTaskTypeModalOpen,
  setReplyParentMsg,
  replyParentMsg,
  selectedGroup,
  handleAssignTask,
  setMessageType,
  selectRecipientsDrawerOpen,
  taskAssignedUser,
  taskModalDeatils,
  isThreadScreenFromTaskApproval,
  isPrivateChatOn,
  setTaskModalDeatils,
  selectedRecipients,

}) => {
  return (
    <ChatInputControl
      handleclickAttherate={handleclickAttherate}
      handleMessageSend={handleMessageSend}
      handleOnChangeNewMessage={handleOnChangeNewMessage}
      newMessages={newMessages}
      handleClickYouTube={handleClickYouTube}
      setFileAttachment={setFileAttachment}
      handleClickGoogle={handleClickGoogle}
      fileAttachment={fileAttachment}
      attachment={attachment}
      isTaskTypeModalOpen={isTaskTypeModalOpen}
      setAttachment={setAttachment}
      setIsTaskTypeModalOpen={setIsTaskTypeModalOpen}
      replyParentMsg={replyParentMsg}
      setReplyParentMsg={setReplyParentMsg}
      selectedGroup={selectedGroup}
      handleAssignTask={handleAssignTask}
      setMessageType={setMessageType}
      selectRecipientsDrawerOpen={selectRecipientsDrawerOpen}
      taskAssignedUser={taskAssignedUser}
      taskModalDeatils={taskModalDeatils}
      isThreadScreenFromTaskApproval={isThreadScreenFromTaskApproval}
      isPrivateChatOn={isPrivateChatOn}
      isTaskUpdateOpen={isTaskUpdateOpen}
      isThreadScreen={isThreadScreen}
      setTaskModalDeatils={setTaskModalDeatils}
      selectedRecipients={selectedRecipients}

    />
  );
};

export default ChatInputWrapper;
